import { render, staticRenderFns } from "./GatewayList.vue?vue&type=template&id=426a2e20&scoped=true"
import script from "./GatewayList.vue?vue&type=script&lang=ts"
export * from "./GatewayList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a2e20",
  null
  
)

export default component.exports